import { observer } from 'mobx-react';
import { OneToolQuoteStepper } from './components/oneToolQuoteStepper';
import { useOneToolStore } from './hooks/useOneToolStore';
import { BorrowerInformationStep } from './steps/borrowerInformation/borrowerInformationStep';
import { LoanSuccessStep } from './steps/common/loanSuccess';
import { EntityInformationStep } from './steps/entityInformation/entityInformationStep';
import { SummaryStep } from './steps/summary/summaryStep';
import { PortfolioInformationStep } from './steps/portfolioInformation/portfolioInformationStep';
import { insertIf } from '@roc/feature-utils';
import { RentalPortfolioLoanDetailsCard } from './steps/loanEconomics/components/rentalPortfolioLoanDetailsCard';
import { PreflightStep } from './steps/preflight/preflightStep';
import { RentalPortfolioPropertyInformationForm } from './steps/propertyInformation/forms/rentalPortfolioPropertyInformationForm';
import { PricerSummaryTermV2 } from './steps/loanPricer/pricerSummaryTermV2';


export const RentalPortfolioQuote = observer(() => {
  const { oneToolStore } = useOneToolStore();
  const { rentalPortfolioQuoteStore } = oneToolStore;

  // useEffect(() => {
  //   const loanEconomicsStore = rentalPortfolioQuoteStore.loanEconomicsStore as RentalPortfolioLoanEconomicsStore;
  //   loanEconomicsStore.fetchExitRate();
  // }, []);

  const steps: JSX.Element[] = [
    <EntityInformationStep key="entity" />,
    <BorrowerInformationStep key="borrower" store={rentalPortfolioQuoteStore} />,
    <PortfolioInformationStep key="portfolioInformation" />,
    ...insertIf(rentalPortfolioQuoteStore.allowPricerStep, [<PricerSummaryTermV2
      key="pricer"
      store={rentalPortfolioQuoteStore} />]
    ),
    <SummaryStep
      key="summary"
      store={rentalPortfolioQuoteStore}
      LoanDetailsCard={RentalPortfolioLoanDetailsCard}
    />
  ];

  return (
    <OneToolQuoteStepper
      title={'Create a Quote - Rental Portfolio Loan'}
      store={rentalPortfolioQuoteStore}
      preflightStep={
        <PreflightStep
          store={rentalPortfolioQuoteStore}
          LoanDetailsCard={RentalPortfolioLoanDetailsCard}
          PropertyInformationForm={RentalPortfolioPropertyInformationForm}
        />
      }
      successStep={<LoanSuccessStep store={rentalPortfolioQuoteStore} />}
    >
      {steps}
    </OneToolQuoteStepper>
  );
});
